import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(home)/chapters/page.tsx");
